/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { components } from 'react-select';
import areMultiProps from '../../helpers/areMultiProps';
import { AsyncMenuList } from './AsyncMenuList';
import VirtualizedMenuList from './VirtualizedMenuList/VirtualizedMenuList';
export function MenuList(props) {
    if (areMultiProps(props) && props.selectProps.rootProps.asyncMenu) {
        return React.createElement(AsyncMenuList, Object.assign({}, props));
    }
    if (props.virtualized && props.virtualizationConfig) {
        return (React.createElement(VirtualizedMenuList, { getValue: props.getValue, options: props.options, virtualizationConfig: props.virtualizationConfig }, props.children));
    }
    return React.createElement(components.MenuList, Object.assign({}, props));
}
//# sourceMappingURL=MenuList.js.map